<template>
  <div class="form-group mod">
    <label :for="id" class="form-label" :class="{'require' : required}">
      {{ title }}
    </label>
    <div class="input-group remove-padding mod">
      <div v-if="prefixLeft" class="input-group-prepend">
        <span class="input-group-text">{{ prefix }}</span>
      </div>
      <input type="tel" class="form-control"
             :placeholder="placeholder"
             :disabled="disable"
             :id="id"
             v-model="nominal.formatted"
      />
      <div v-if="prefixRight" class="input-group-prepend">
        <span class="input-group-text">{{ prefix }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SOInputNumeric",
  props: {
    title: String,
    id: String,
    placeholder: String,
    required: Boolean,
    prefix: String,
    prefixRight: Boolean,
    prefixLeft: Boolean,
    disable: Boolean,

    defaultValue: Number,
    maxLength: Number,
  },
  data() {
    return {
      nominal: {
        formatted: "",
        nominalMaxLength: 0,
        raw: 0,
      },
    }
  },
  watch: {
    "nominal.formatted": {
      handler: function (v) {
        this.nominal.formatted = this.regexingNominal(v)
        if (this.nominal.nominalMaxLength !== 0) {
          if (this.nominal.formatted.length <= this.maxLength) {
            this.nominal.nominalMaxLength = this.nominal.formatted
          } else {
            this.nominal.formatted = this.nominal.nominalMaxLength
          }
        }
      },
    },
  },
  methods: {
    regexingNominal(value) {
      var nominalRegex;
      nominalRegex = value.replace(/[^0-9]+/g, "");
      this.$emit("input", nominalRegex)
      return nominalRegex
    },
  },
  mounted() {
    if (this.defaultValue !== undefined) {
      this.nominal.formatted = this.regexingNominal(this.defaultValue)
    }
  }
}
</script>